import axios from 'axios';

const instance = axios.create({
   baseURL: process.env?.REACT_APP_API_URL || "https://api.litextension.com/",
   // baseURL: process.env?.REACT_APP_API_URL || 'https://cm1.litextension.com/new-laravel/public/',
});

export default instance;
